import _util from '../../utils/';

const attendanceTemplateService = {
	fetchAttendanceTemplateList(gets, resolve, reject) {
		_util.request({
			url: '/api/HRAttendanceTemplate/Get',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	createAttendanceTemplate (data, resolve, reject) {
    	_util.request({
            url: '/api/HRAttendanceTemplate/Post',
            method: 'POST',
            data: data,
            success: resolve,
            error: reject
        })
    },
    updateAttendanceTemplate (data, resolve, reject) {
    	_util.request({
            url: '/api/HRAttendanceTemplate/Put',
            method: 'PUT',
            data: data,
            success: resolve,
            error: reject
        })
    },
    deleteAttendanceTemplate (data, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceTemplate/Delete',
            method: 'DELETE',
            data: data,
            success: resolve,
            error: reject
        })
    },
    InitializationAttendanceTemplate (gets, resolve, reject) {
    	_util.request({
            url: '/api/HRAttendanceTemplate/View',
            params: gets,
            success: resolve,
            error: reject
        })
    },
    multiDelete(deletes, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceTemplate/Delete',
            method: 'delete',
            data: deletes,
            success: resolve,
            error: reject
        });
    },
    exportTemplate(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceTemplate/Export',
            params: gets,
            success: resolve,
            error: reject
        })
    },
    downloadTemplate(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceTemplate/GetImportTemplate',
            params: gets,
            success: resolve,
            error: reject
        });
    },
    importTemplate(data, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceTemplate/Import',
            method: 'POST',
            data: data,
            success: resolve,
            error: reject
        });
    },
    selectAttendanceTemplateRecord(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceTemplate/GetDetailList',
            params: gets,
            success: resolve,
            error: reject
        })
    },
    // selectAttendanceTemplateRecord(data, resolve, reject) {
    //     _util.request({
    //         url: '/api/HRAttendanceTemplate/GetDetailList',
    //         params: data,
    //         success: resolve,
    //         error: reject
    //     })
    // },
}

export default attendanceTemplateService;


// WEBPACK FOOTER //
// ./src/services/Attendance/attendance-template-service.js